import { useQuery } from '@tanstack/react-query';
import { ICycle } from 'models/cycle/cycle.model';
import api from 'services/api/api';

export const getCycle = async (): Promise<ICycle[]> => {
	const response = await api.get(`/ciclo`);
	return response.data;
};
export const useCycleList = () => {
	return useQuery(['cycle-list'], getCycle, {
		refetchOnWindowFocus: false,
	});
};
